import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import agentReducer from './slices/agentSlice';
import carrierReducer from './slices/carrierSlice';
import stateReducer from './slices/stateSlice';
import changeRequestReducer from './slices/changeRequestSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    agents: agentReducer,
    carriers: carrierReducer,
    states: stateReducer,
    changeRequests: changeRequestReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types if needed
        ignoredActions: ['your/action/type'],
      },
    }),
});

export default store;
